// XNGAGE CONFIDENTIAL
// __________________________
//
// Copyright (C) 2023 Xngage - All Rights Reserved
//
// All code or information contained herein is, and remains the
// property of Xngage LLC and its customers.  The intellectual
// and technical concepts contained are proprietary to Xngage LLC
// and may be covered by U.S. and Foreign Patents, patents in
// process, and are protected by trade secret or copyright law.
// Dissemination of this information or reproduction of this material
// is strictly forbidden unless prior written permission is obtained
// from Xngage LLC.
//

import { EMPTY_VALUE } from "@flip/XDL/constants";
import { fontConfig } from "@flip/XDL/PreStyle/typography";
import mergeToNew from "@insite/client-framework/Common/mergeToNew";
import getLocalizedDateTime from "@insite/client-framework/Common/Utilities/getLocalizedDateTime";
import { Session } from "@insite/client-framework/Services/SessionService";
import translate from "@insite/client-framework/Translate";
import { QuoteModel, QuoteSettingsModel } from "@insite/client-framework/Types/ApiModels";
import RfqQuoteDetailsPageTypeLink from "@insite/content-library/Components/RfqQuoteDetailsPageTypeLink";
import SmallHeadingAndText, { SmallHeadingAndTextStyles } from "@insite/content-library/Components/SmallHeadingAndText";
import { DataTableCellProps } from "@insite/mobius/DataTable/DataTableCell";
import GridContainer, { GridContainerProps } from "@insite/mobius/GridContainer";
import GridItem, { GridItemProps } from "@insite/mobius/GridItem";
import { DataTableCell, DataTableRow } from "@insite/mobius/index";
import TypographyStyle from "@insite/mobius/Typography/TypographyStyle";
import React, { FC } from "react";
import { css } from "styled-components";

interface OwnProps {
    quote: QuoteModel;
    session: Session;
    quoteSettings: QuoteSettingsModel;
    extendedStyles?: QuoteSummaryCardStyles;
}

type Props = OwnProps;

export interface QuoteSummaryCardStyles {
    // quoteSummaryCardGridItem?: GridItemProps;
    // container?: GridContainerProps;
    // quoteDetailsLinkGridItem?: GridItemProps;
    // typeGridItem?: GridItemProps;
    // typeHeadingAndText?: SmallHeadingAndTextStyles;
    // statusGridItem?: GridItemProps;
    // statusHeadingAndText?: SmallHeadingAndTextStyles;
    // orderDateGridItem?: GridItemProps;
    // orderDateHeadingAndText?: SmallHeadingAndTextStyles;
    // expirationDateGridItem?: GridItemProps;
    // expirationDateHeadingAndText?: SmallHeadingAndTextStyles;
    // salesRepGridItem?: GridItemProps;
    // salesRepHeadingAndText?: SmallHeadingAndTextStyles;
    // userNameGridItem?: GridItemProps;
    // userNameHeadingAndText?: SmallHeadingAndTextStyles;
    // customerGridItem?: GridItemProps;
    // customerHeadingAndText?: SmallHeadingAndTextStyles;
    // shipToAddressGridItem?: GridItemProps;
    // shipToAddressHeadingAndText?: SmallHeadingAndTextStyles;

    // XNG-Changes
    quoteNumberCells?: DataTableCellProps;
}

export const quoteSummaryCardStyles: QuoteSummaryCardStyles = {
    // quoteSummaryCardGridItem: {
    //     width: 12,
    //     css: css`
    //         padding: 0 20px;
    //         max-width: 500px;
    //     `,
    // },
    // container: {
    //     gap: 5,
    // },
    // quoteDetailsLinkGridItem: { width: 12 },
    // typeGridItem: { width: 6 },
    // statusGridItem: { width: 6 },
    // orderDateGridItem: { width: 6 },
    // expirationDateGridItem: { width: 6 },
    // salesRepGridItem: { width: 6 },
    // userNameGridItem: { width: 6 },
    // customerGridItem: { width: 6 },
    // shipToAddressGridItem: { width: 6 },

    // XNG-Changes
    quoteNumberCells: {
        css: css`
            ${TypographyStyle} {
                font-size: 14px;
                font-weight: ${fontConfig.weight.semiBold};
                line-height: 22px;
            }
        `,
    },
};

const QuoteSummaryCard: FC<Props> = ({ quote, session, quoteSettings, extendedStyles }) => {
    const [styles] = React.useState(() => mergeToNew(quoteSummaryCardStyles, extendedStyles));

    // XNG-Changes: FLIP-894
    const orderDateDisplay = getLocalizedDateTime({
        dateTime: quote.orderDate!,
        language: session.language,
        options: {
            year: "numeric",
            month: "2-digit",
            day: "2-digit",
        },
    });

    // let expirationDateDisplay = "";
    // if (quote.expirationDate) {
    //     expirationDateDisplay = getLocalizedDateTime({
    //         dateTime: quote.expirationDate,
    //         language: session.language,
    //         options: {
    //             year: "numeric",
    //             month: "numeric",
    //             day: "numeric",
    //         },
    //     });
    // }
    const customerDisplay = `${quote.customerNumber} - ${quote.customerName}`;

    // XNG-Changes: structure
    return (
        <DataTableRow data-test-selector="recentQuotes">
            <DataTableCell {...styles.quoteNumberCells}>
                <RfqQuoteDetailsPageTypeLink title={quote.quoteNumber} quoteId={quote.id} />
            </DataTableCell>
            {/* {quoteSettings.jobQuoteEnabled && <DataTableCell>{quote.typeDisplay}</DataTableCell>} */}
            <DataTableCell>{orderDateDisplay}</DataTableCell>
            <DataTableCell>{customerDisplay}</DataTableCell>
            <DataTableCell>{quote.statusDisplay}</DataTableCell>
            {session.isSalesPerson ? (
                <>
                    <DataTableCell>{quote.salespersonName}</DataTableCell>
                    <DataTableCell>{quote.userName}</DataTableCell>
                </>
            ) : (
                <DataTableCell>{quote.shipToFullAddress}</DataTableCell>
            )}
            {/* <DataTableCell>{expirationDateDisplay}</DataTableCell> */}
        </DataTableRow>
    );
};

export default QuoteSummaryCard;
